import { motion, useReducedMotion } from 'framer-motion';
import './Card.css';

const defaultVariants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0 },
};

function Card({
  children,
  interactive = false,
  padding = 'md',
  className = '',
  variants,
  as,
  ...rest
}) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className={`ds-card ds-card-pad-${padding} ${interactive ? 'ds-card-interactive' : ''} ${className}`.trim()}
      variants={variants || defaultVariants}
      whileHover={
        interactive && !reduceMotion ? { y: -3, boxShadow: 'var(--ds-shadow-lg)' } : undefined
      }
      transition={{ duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

function CardHeader({ title, subtitle, action }) {
  return (
    <div className="ds-card-header">
      <div>
        <div className="ds-card-title">{title}</div>
        {subtitle && <div className="ds-card-subtitle">{subtitle}</div>}
      </div>
      {action && <div className="ds-card-header-action">{action}</div>}
    </div>
  );
}

function CardFooter({ children }) {
  return <div className="ds-card-footer">{children}</div>;
}

Card.Header = CardHeader;
Card.Footer = CardFooter;

export default Card;
